import { AccountServiceBase } from "../../config";
import { checkResponseErrors, makeRequestInit } from '../fetchHelper';
import { ProfileData } from './ProfileData';
import type { Authentication } from "../auth/Authentication";

export class ProfileEndpoints {
    private _auth: Authentication;

    constructor(auth: Authentication) {
        this._auth = auth;
    }

    _dofetch(url: string, init: RequestInit) {
        return this._auth
            .fetch(AccountServiceBase + url, init)
            .then(checkResponseErrors);
    }

    getProfile() {
        const init = makeRequestInit('GET');
        return this._dofetch('/profile', init)
            .then(rsp => rsp.json())
            .then(json => new ProfileData(json));
    }

    changePassword(currentPassword: string, newPassword: string) {
        const init = makeRequestInit('POST', {
            CurrentPassword: currentPassword,
            NewPassword: newPassword,
        });
        return this._dofetch('/profile/changepassword', init).then(() => void (0));
    }
}
